export default "__VITE_ASSET__CnQdqTMc__"